import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Table, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import fileDownload from "js-file-download";
import _ from "lodash";

import { ReactComponent as ExcelIcon } from "@/assets/images/icons/Inventory/excel.svg";

import Pagination from "@/components/Pagination/Pagination";
import Fetching from "@/components/Fetching/Fetching";

import { dateToLocale, formatMilesDecimalNew, isMobile } from "@/services/Utils";
import api from "@/services/api.service";

import classes from "./dashboard-expiration.module.scss";

const DashboardExpirationTable = ({ index, show, setShow }) => {
	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);
	const [fetching, setFetching] = useState(true);
	const [mainSearch, setMainSearch] = useState("");
	const [search, setSearch] = useState("");
	const [paginate, setPaginate] = useState(8);
	const [page, setPage] = useState(1);
	const [quantityElements, setQuantityElements] = useState(0);
	const [lastPage, setLastPage] = useState(0);
	const [fromElements, setFromElements] = useState(0);
	const [toElements, setToElements] = useState(0);
	const [defaultUnit, setDefaultUnit] = useState(1000);
	const [elements, setElements] = useState([]);

	useEffect(() => {
		const form = {
			index,
			page,
			defaultUnit,
			search,
			paginate,
			estate_parent_id,
			estate_id,
			type_currency,
		};

		if ((index || index === 0) && show) {
			setFetching(true);
			api.get("/client/get_table_expiration", form).then((response) => {
				updateData(response);
			});
		}
		// eslint-disable-next-line
	}, [index, page, defaultUnit, search, paginate, estate_parent_id, estate_id, show]);

	const updateData = (data) => {
		setQuantityElements(data.data.inventories.total);
		setFromElements(data.data.inventories.from);
		setToElements(data.data.inventories.to);
		setLastPage(data.data.inventories.last_page);
		setElements(data.data.inventories.data);
		setFetching(false);
	};

	const closeModal = () => {
		setPage(1);
		setShow(false);
	};

	const handleExport = () => {
		const form = {
			index,
			page,
			defaultUnit,
			search,
			paginate,
			estate_id,
		};

		setFetching(true);
		api.getExcel("/client/export_table_expiration", form).then((response) => {
			const date = new Date();

			const filename = `Inventario  ${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;
			fileDownload(response, filename);

			setFetching(false);
		});
	};

	const delayedQuery = useMemo(
		() =>
			_.debounce((value) => {
				setSearch(value);
			}, 500),
		[],
	);

	useEffect(() => {
		return () => {
			delayedQuery.cancel();
		};
	}, [delayedQuery]);

	const setDelaySearch = (value) => {
		setMainSearch(value);
		delayedQuery(value);
	};

	return (
		<Modal show={show} backdrop="static" keyboard={false} onHide={() => closeModal(false)} size="lg">
			<Modal.Header closeButton>
				<Modal.Title>Productos</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<div style={{ width: "100%", marginBottom: "10px" }}>
					<Row>
						<Col md={11} sm={11}>
							<Pagination
								page={page}
								setPage={setPage}
								paginate={paginate}
								setPaginate={setPaginate}
								search={mainSearch}
								setSearch={setDelaySearch}
								quantityElements={quantityElements}
								LastPage={lastPage}
								FromElements={fromElements}
								ToElements={toElements}
								defaultUnit={!isMobile() && defaultUnit}
								setDefaultUnit={setDefaultUnit}
							/>
						</Col>

						{!isMobile() && (
							<Col>
								<OverlayTrigger overlay={<Tooltip>Exportar Excel</Tooltip>}>
									<ExcelIcon
										style={{
											width: "2em",
											height: "2em",
											cursor: "pointer",
											fill: "#81ba43",
										}}
										onClick={() => handleExport()}
									/>
								</OverlayTrigger>
							</Col>
						)}
					</Row>
				</div>

				{fetching ? (
					<Fetching topMargin="3em" bottomMargin="3em" />
				) : (
					<Table striped bordered hover className={classes.table_dashboard}>
						<thead>
							<tr>
								<th className={classes.th}>Código</th>
								<th className={classes.th}>Producto</th>
								{!isMobile() && (
									<>
										<th className={classes.th}>Contenido Restante</th>
										<th className={classes.th}>Unidad de Medida</th>
										<th className={classes.th}>Fecha de Vencimiento</th>
									</>
								)}
							</tr>
						</thead>
						<tbody>
							{elements.map((element, index) => {
								return (
									<tr key={index}>
										<td className={classes.td}>{element.IDENTIFICADOR}</td>
										<td className={classes.td}>{element.NOMBRE_COMERCIAL}</td>
										{!isMobile() && (
											<>
												<td className={classes.td}>{element.STOCK && formatMilesDecimalNew(element.STOCK)}</td>
												<td className={classes.td}>{element.UNIDAD_DE_MEDIDA}</td>
												<td className={classes.td}>{element.FECHA_DE_VENCIMIENTO && dateToLocale(element.FECHA_DE_VENCIMIENTO)}</td>
											</>
										)}
									</tr>
								);
							})}
						</tbody>
					</Table>
				)}
			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={() => closeModal(false)}>
					Cerrar
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default DashboardExpirationTable;
